import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth.service";
import { filter, firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthGuard {
    constructor(
        private readonly _router: Router,
        private readonly _authService: AuthService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        await firstValueFrom(this._authService.checkAuthStatusComplete$.pipe(
            filter(v => v === true),
        ));
        if (this._authService.user) {
            return true;
        } else {
            this.saveUrl(state.url);
            return this._router.createUrlTree(["/login"]);
        }
    }

    private saveUrl(url: string) {
        localStorage.setItem("postLoginRedirectUrl", url);
    }
}
